module.exports = __webpack_public_path__ + "0c78b0c8a7eea9f328f96f0c2bd11278.png";